import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { firstValueFrom, Observable } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { getIndicatorByObjective } from './querys';

export class Indicadores{
  public objectiveId?: Number;
  public areaId?: Number;
  public measureId?: Number;
  public name?: String;
  public description?: String;
  public calculation?: String;
  public baseline?: String;
  public periodicity?: String;
  public initialDate?: Date;
  public endDate?: Date;
  public weighing?: Number;
  public globalGoal?: Number;
  public tendency?: string;
  public paramType?: string;
}

@Injectable({
  providedIn: 'root'
})
export class IndicadorService {
  private apiURL = environment.apiURL_institucion;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private http: HttpClient, 
    private cookies: CookieService,
    private apollo: Apollo
  ) { }

  public getUnides(): Observable<any>{
    const apiURL = this.apiURL+"medidas";
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }

  public getIndicadores(): Observable<any>{
    const apiURL = this.apiURL+"indicador";
    return this.http.get(`${apiURL}`, {headers: this.headers});
  }

  async getIndicadoresByObjetiveGQL(id: number): Promise<any[]> {
    const allData: any[] = [];
    let currentPage = 1;
    let hasNextPage = true;

    while (hasNextPage) {
      const { data } = await firstValueFrom(
        this.apollo.use(environment.apiURL_gestion).watchQuery<any>({
          query: getIndicatorByObjective,
          context: { headers: this.headers },
          variables: {
            args: {
              filter: {
                conditions: [
                  {
                    field: "objectiveId",
                    operator: "EQUAL",
                    value: id
                  }
                ]
              },
              pagination: {
                page: currentPage
              }
            }
          },
          fetchPolicy: 'no-cache'
        }).valueChanges
      );

      const { data: indicators, metadata } = data.searchIndicators;
      allData.push(...indicators);

      hasNextPage = metadata.hasNextPage;
      currentPage++;
    }

    return allData;
  }

  public postIndicadores(indicador: any): Observable<any>{
    const ind: Indicadores = {
      objectiveId: indicador.objetiveId,
      areaId: Number(indicador.areaId),
      measureId: Number(indicador.measureId),
      name: indicador.nombre,
      description: indicador.descripcion,
      calculation: indicador.calculo,
      baseline: indicador.linea_base,
      periodicity: indicador.periodicidad,
      initialDate: indicador.fecha_inicio.toISOString(),
      endDate: indicador.fecha_fin.toISOString(),
      weighing: indicador.ponderacion?Number(indicador.ponderacion):0,
      globalGoal: Number(indicador.meta_global),
      tendency: indicador.tendencia,
      paramType: indicador.parametro,
    }
    const body = JSON.stringify(ind);
    const apiURL = this.apiURL+"indicador";
    return this.http.post(`${apiURL}`,body, {headers: this.headers});
  }
  public patchIndicadores(indicador: any): Observable<any>{
    const ind: Indicadores = {
      objectiveId: indicador.objetiveId,
      areaId: Number(indicador.areaId),
      measureId: Number(indicador.measureId),
      name: indicador.nombre,
      description: indicador.descripcion,
      calculation: indicador.calculo,
      baseline: indicador.linea_base,
      periodicity: indicador.periodicidad,
      initialDate: indicador.fecha_inicio.toISOString(),
      endDate: indicador.fecha_fin.toISOString(),
      weighing: Number(indicador.ponderacion),
      globalGoal: Number(indicador.meta_global),
      tendency: indicador.tendencia,
      paramType: indicador.parametro,
    }
    const body = JSON.stringify(ind);
    const apiURL = this.apiURL+"indicador/"+indicador.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }
  public patchIndicadoresFechaFin(indicador: any): Observable<any>{
    const ind: Indicadores = {
      endDate: indicador.fecha_fin.toISOString(),
    }
    const body = JSON.stringify(ind);
    const apiURL = this.apiURL+"indicador/"+indicador.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }
  public patchIndicadoresPond(indicador: any): Observable<any>{
    const ind: Indicadores = {
      weighing: Number(indicador.ponderacion),
    }
    const body = JSON.stringify(ind);
    const apiURL = this.apiURL+"indicador/"+indicador.id;
    return this.http.patch(`${apiURL}`,body, {headers: this.headers});
  }
  public deleteIndicadores(indicador: any): Observable<any>{
    const apiURL = this.apiURL+"indicador/"+indicador.id;
    return this.http.delete(`${apiURL}`, {headers: this.headers});
  }
}
